import AuthRequestHelper from './AuthRequestHelper'

class AIProfileHelper {
  async getAllProfiles() {
    try {
      // Use no-token request because the aiprofiles endpoint is not secured
      const resp = await AuthRequestHelper.requestNoToken('get', 'aiprofiles', {})
      // Normalize server response: ensure `data` is an array
      if (!resp) return { status: 'success', data: [] }
      if (!resp.hasOwnProperty('data') || resp.data === null) {
        return { status: resp.status || 'success', data: [] }
      }
      return resp
    } catch (e) {
      console.error('Failed to load AI profiles', e)
      return { status: 'error', data: [] }
    }
  }

  async getRecommended(userId, matchNo = 5) {
    try {
      const params = { matchNo }
      const path = `aiprofiles/recommend/${encodeURIComponent(userId)}`
      const resp = await AuthRequestHelper.requestNoToken('get', path, params)
      if (!resp) return { status: 'success', data: [] }
      if (!resp.hasOwnProperty('data') || resp.data === null) {
        return { status: resp.status || 'success', data: [] }
      }
      return resp
    } catch (e) {
      console.error('Failed to load recommended AI profiles', e)
      return { status: 'error', data: [] }
    }
  }
}

export default new AIProfileHelper()
